export class TradePositionsModel {
setValue(res){
if(res){
}
}
}